import busWhite from './assets/bus-white.webp';
import flightWhite from './assets/flight-white.webp';
import hotelWhite from './assets/hotel-white.webp';
import mobilityWhite from './assets/mobility-white.png';
import rentalWhite from './assets/rental-white.webp';
import seatWhite from './assets/seat-white.webp';
import trainWhite from './assets/train-white.webp';

/**
 * The design system's service illustrations — renders, not vectors: a white
 * object with a terracotta accent, 3/4 view, soft shadow. One catalog for every
 * surface that draws a service: the guided-flow shortcuts and the chat's
 * next-services rows. The DS also ships a beige-background version; product
 * decided the white one is used everywhere (the art never swaps on hover).
 *
 * The files are imported rather than referenced by URL so the bundler
 * fingerprints them with the rest of the bundle — the kit does not know the
 * host's asset base.
 *
 * WebP q92, re-encoded from the DS jpgs: ~4 KB per render against ~21 KB, with
 * a mean difference of ~1.4/255 per pixel — invisible at this size. The
 * originals are 160×160, so above 2x the art softens; when the DS delivers
 * @2x/@3x, swapping the file is enough (the import does not change).
 */
export const SERVICE_ART = {
  flight: flightWhite,
  hotel: hotelWhite,
  rental: rentalWhite,
  bus: busWhite,
  // O sedã com o relógio do Agendamento (Figma H5.0a, #6797): PNG 160×160 recortado do
  // render do Figma, sem o webp do DS ainda.
  mobility: mobilityWhite,
  seat: seatWhite,
  train: trainWhite,
} as const;

export type ServiceArtKey = keyof typeof SERVICE_ART;
